import React from 'react';
import Navbar from 'components/Header/Navbar';
import CorporateProfileForm from 'components/Profile/CorporateProfileForm';

const Profil_kurumsal: React.FC = () => {
  return (
    <div className="min-vh-100" style={{ backgroundColor: 'var(--sb-bg-muted)' }}>
      <Navbar />
      <main className="container py-4">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <CorporateProfileForm />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Profil_kurumsal;
